<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="14" fill="#D9D9D9"/>
    <path d="M7.11816 14.2373H20.4063" stroke="black" stroke-width="2"/>
    <path d="M13.7627 7.59326L13.7627 20.8814" stroke="black" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'opener-icon'
}
</script>

<style scoped>

</style>
